nudgeHandler = {};
nudgeHandler.nudgeSymbolAssets = [];

symbolKeys = {
  0: "L5",
  1: "L4",
  2: "L3",
  3: "L2",
  4: "L1",
  12: "H4",
  13: "H3",
  14: "H2",
  15: "H1",
  16: "StandardDevil",
  17: "BoostDevil",
  18: "MultiDevil",
  19: "RespinDevil",
  20: "L5",
  21: "L4",
  22: "L3",
  23: "L2",
  24: "L1",
};

nudgeHandler.nudgeSymbols = async (nudgeModifier, endSymbol) => {
  const { nudgeSymbols, isUpNudge } = nudgeModifier;

  const reelContainer = resourceManager.get("slotContainer:reelContainer:reel7");
  const landedSymbol = resourceManager.get("slotContainer:reelContainer:reel7:symbol0");

  // set visibile false as we're replacing with duplicated version to nudge
  landedSymbol.visible = false;
  reelContainer.setReelSymbol(0, endSymbol);

  const nudgeSymbolOffset = 176;
  [...nudgeSymbols, endSymbol].forEach((id, i) => {
    const symbolNudgeAsset = resourceManager.createObject("movie", `nudgeSymbolID:${id}${i}`, reelContainer, {
      definition: symbolKeys[id],
      anchor: 0.5,
      loop: false,
      x: 0,
      y: (isUpNudge ? 1 : -1) * nudgeSymbolOffset * i,
    });
    symbolNudgeAsset.gotoAndStop(0);
    nudgeHandler.nudgeSymbolAssets.push(symbolNudgeAsset);
  });

  await gameController.devilCharacter.nudge();
  gameController.respinAnticipationSymbolFrames[7].frame.play();
  gameController.respinAnticipationSymbolFrames[7].frame.alpha = 1;

  soundManager.play("middleReelSpin");
  for (let i = 0; i < nudgeSymbols.length; i++) {
    // loop over each asset but nudge all of them
    await gsap.to(nudgeHandler.nudgeSymbolAssets, {
      y: `${isUpNudge ? "-" : "+"}=${nudgeSymbolOffset}`,
      duration: 0.5,
      delay: i > 0 ? 0.5 : 0,
      onStart: () => {
        soundManager.play("devilNudge2");
      },
    });
  }
  soundManager.stop("middleReelSpin");
  soundManager.play("middleReelStop");

  gameController.devilCharacter.playLockWiggle();

  gameController.respinAnticipationSymbolFrames[7].frame.gotoAndStop(0);
  gsap.to(gameController.respinAnticipationSymbolFrames[7].frame, { alpha: 0, duration: 0.5 });

  // RESET \\
  landedSymbol.visible = true;
  // get rid of all of the other symbol that were nudged
  nudgeHandler.nudgeSymbolAssets.forEach((nudgeAsset) => {
    resourceManager.destroyObject(nudgeAsset.name);
  });
  nudgeHandler.nudgeSymbolAssets.length = 0;
};
